import React, { Component } from "react";
import BsySearchResult from "../../BsySearchResult";
import Content from "./content";
import BsyAlertTextEdit from "../../BsyAlertTextEdit";
import { BsyUtils } from "../../../utils/Utils";
import Tree from "rc-tree";

import "./index.css";
import { withRouter } from "react-router-dom";
import BsyMsgBubble from "../../BsyMsgBubble";
import BsySelectFormGroup from "../BsySelectFormGroup";
import BsyDialog from "../../BsyDialog";
import BsyRecyclePane from "../../BsyRecyclePane";
import DocumentTitle from "react-document-title";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import BsySlidePane from "../../BsySlidePane";
import BsyRelationshipForm from "../../BsyRelationshipForm";
import NameCorrespondenceSetting from "../../BsyVirtualAddressBook/NameCorrespondenceSetting";
import BsyMaskLayer from "../../BsyMaskLayer";
import { ChangeAppPane } from "./changeApp";
import BsySystemRightMenu from "../../BsySystemRightMenu";
import BsyVirtualAddressBook from "../../BsyVirtualAddressBook";
import BsySystemLeftMenu from "../../BsySystemLeftMenu";
import { CreateForm } from "./createForm";
import { CreateDash } from "./createDash";
import axios from "axios";
import { ErrorComponent } from "../../../utils/errorCompoents";
import BsyIconBtn from "../../BsyIconBtn";
import img_liucheng from "../../../images/dashboard/img_liucheng.png";
import img_biaodan from "../../../images/dashboard/img_biaodan.png";
import img_baobiao from "../../../images/dashboard/img_baobiao.png";
import { BrowserRouter } from "react-router-dom/cjs/react-router-dom";
import { setPageTitle } from "../../../utils/setPageTitle";
class BsyDashboardApp extends Component {
  constructor(props) {
    super(props);
    this.body = React.createRef();
    this.menu = React.createRef();
    this.menuTree = React.createRef();
    this.contentRef = React.createRef();
    this.state = {
      notFoundApp: false,
      isFlow: !1,
      isOwner: !1,
      treeNodes: [],
      entryList: [],
      showContent: !1,
      dock: !1,
      editable: !1,
      deletable: !1,
      copyable: !1,
      flowCount: 0,
      emptyCont: !1,
      emptyTip: "",
      entryMap: [],
      groupExpandedMap: {},
      appid: props.match.params.appid,
      entryid: props.match.params.entryid,
      type: props.match.params.type,
      routePath: props.routePath,
      isLoading: true,
      expandedKeys: ["1"],
      startNode: null,
      overNode: null,
      isEnter: false,
      flowMenuExpand: false, //流程菜单默认是关闭状态
      appType: -1,
      apps: [],
      dockItem: [],
      isAppEmpty: true, // 应用是否为空
      virtualType: 1,
      favoritesItems: null,
    };
    this.flownumref = React.createRef();
    this.treeNodeskey = "";
  }
  NAV = {
    MESSAGE: 1,
    ACCOUNT: 2,
    FAVORITE: 3,
  };
  CONSTS = {};
  THEME = {
    config4frame: {
      resizable: !0,
      north: {
        visible: !0,
      },
      south: {
        visible: !1,
      },
      east: {},
    },
    config4Gallery: {
      region: null,
    },
    config4MenuTree: {
      region: "west",
    },
    config4tabPane: {
      style: "alpha",
      region: "east",
      isCollapsible: !1,
      hasHomepageBtn: !0,
    },
  };

  formNumberMax = window.FX.STATIC.FORMCOUNTMAX;

  firstTime = true;

  FlowMenuData = [
    {
      id: "todo",
      text: React.language("flow.todo"),
      type: "flow",
    },
    {
      id: "cc",
      text: React.language("flow.my.cc"),
      type: "flow",
    },
    {
      id: "transactors",
      text: React.language("flow.my.transactors"),
      type: "flow",
    },
    {
      id: "create",
      text: React.language("flow.visit.create"),
      type: "flow",
    },
  ];

  flowstatuse = { todo: !1, create: !1, part: !1 };

  _sortEntryList = (a, b) => {
    a.sort(function (a, c) {
      let d = b[a.id] && b[a.id].seq,
        e = b[c.id] && b[c.id].seq;
      if (d !== e) return d - e;
      let f = b[a.id] && b[a.id].entryId,
        g = b[c.id] && b[c.id].entryId,
        h = 0;
      f > g ? (h = 1) : f < g && (h = -1);
      return h;
    });
    return a;
  };

  getFisrstEntry = (entryList, entryMap) => {
    let dd = {
      entryid: "",
      type: "",
    };
    for (let i = 0; i < entryList.length; i++) {
      if (entryList[i].child) {
        if (entryList[i].child.length) {
          var firstChild = entryList[i].child;
          // 第一层分组
          for(let j = 0; j < firstChild.length; j++) {
            if(firstChild[j].child) {
              // 第二层分组 
              for(let k = 0; k < firstChild[j].child.length; k++) {
                if(firstChild[j].child[k].child) {
                  dd.entryId = firstChild[j].child[k].child[0].id;
                  break;
                } else {
                  dd.entryId = firstChild[j].child[k].id;
                  dd.entryid = firstChild[j].child[k].id;
                  dd.type = entryMap[dd.entryId].type;
                }
              }
              break;
            } else {
              dd.entryId = firstChild[j].id;
              dd.entryid = firstChild[j].id;
              dd.type = entryMap[dd.entryId].type;
              break;
            }
          }
          break;
        }
      } else {
        dd.entryId = entryList[i].id;
        dd.entryid = entryList[i].id;
        break;
      }
    }
    dd.type = entryMap[dd.entryId].type;
    return dd;
  };

  findApp = (id, apps) => {
    return apps.find((res) => res._id === id);
  };

  loadAppList = async (id, entryid, type) => {
    const resdata = window.g_apps
      ? { data: { items: window.g_apps } }
      : await React.axios("/dashboard/app_group/list");
    window.g_apps = [...resdata.data.items, ...(resdata.data.dock_items || [])];

    this.setState(
      {
        isLoading: true,
        apps: window.g_apps,
      },
      () => {
        window.FX.STATIC.APPID = id;
        window.$(this.menuTree.current).sortable("destroy");
        React.axios("/dashboard/app/" + id, {})
          .then(async (res) => {
            const b = res.data;
            this.firstTime = true;
            let form = [];
            window.FX.STATIC.user.dock_userid = res.data.dock_userid;
            window.FX.STATIC.user_corps.timezone = res.data.timezone;
            window.FX.STATIC.entryConfig = {
              appType: res.data.appType,
            };
            window.FX.STATIC.APPTYPE = res.data.appType;

            let standardAppData = [];
            let app = null;
            if (b.appType === 3) {
              const data = await React.axios(
                "/dashboard/standardapp_group/list"
              );
              standardAppData = [...data.data.items];
              app = standardAppData.find((res) => {
                return this.findApp(id, res.apps);
              });
            } else {
              app = window.g_apps.find((res) => {
                return this.findApp(id, res.apps);
              });
            }
            // 后端存在一个bug 会导致前端白屏，所以需要前端判断处理
            if (!app) {
              this.setState({
                notFoundApp: true,
              });
              return;
            }

            BsyUtils.forEach(b.entryList, (obj, res) => {
              if (b.entryMap[res.id]) {
                if (
                  b.entryMap[res.id].type === "form" ||
                  b.entryMap[res.id].type === "dash" ||
                  b.entryMap[res.id].type === "report"
                ) {
                  form.push(b.entryMap[res.id]);
                }
              } else {
                // console.log('不存在form ', res)
              }

              if (res.hasOwnProperty("child")) {
                BsyUtils.forEach(res.child, (obj, res1) => {
                  if (b.entryMap[res1.id]) {
                    form.push(b.entryMap[res1.id]);
                  } else {
                    // console.log('不存在form ', res1)
                  }
                });
              }
            });

            window.$.extend(window.FX.STATIC, {
              ENTRYIDALIASMAP: b.entryIdAliasMap, //别名对应的表真实id 用于别名跳转 zhxj190330
            });
            // let entryid = "";
            // let type = '';
            if (b.isFlow) {
              let backEntryId = entryid;
              this._refreshTodoCount(id, backEntryId, () => {
                if (backEntryId) {
                  //在选中了流程相关的 待办 抄送 发起的，参与的 直接跳过按默认逻辑处理
                  return;
                }
                //直接访问应用，如果没有待办，跳第一个表单

                if (b.entryList.length) {
                  let dd = this.getFisrstEntry(b.entryList, b.entryMap);
                  entryid = dd.entryId || entryid;
                  type = dd.type || type;
                }
                let apps = [
                  ...this.state.apps,
                  ...this.state.dockItem,
                  ...standardAppData,
                ];

                apps.map((res) => {
                  res.apps.map((val) => {
                    if (val._id === id) {
                      this.setState(
                        {
                          dock: val.dock,
                          editable: val.editable,
                          deletable: val.deletable,
                          copyable: val.copyable,
                          showContent: !0,
                          emptyCont: !1,
                          isAppEmpty: false,
                          isFlow: b.isFlow,
                          isOwner: b.isOwner,
                          entryMap: b.entryMap,
                          entryList: b.entryList,
                          titleName: b.name,
                          appName: b.name,
                          appType: val.appType,
                          treeNodes: this._sortEntryList(
                            b.entryList,
                            b.entryMap
                          ),
                          entryid: entryid,
                          appid: id,
                          type: type,
                          style: val.style,
                          isLoading: false,
                          flowCount: 0,
                          flowMenuExpand: false,
                          showSearch: true,
                        },
                        () => {
                          this._initEntrySort();
                          this.initTreescrollTop();
                        }
                      );
                    }
                    return null;
                  });
                  return null;
                });
              });
              entryid = entryid || "todo";
              type = type || "flow";
              if (entryid === "todo") {
                this.props.history.push(
                  window.rootDirectroy +
                  "/team/app/" +
                  id +
                  `/${type}/${entryid}`
                );
                // return;
              }
            } else {
              if (b.entryList.length) {
                let dd = this.getFisrstEntry(b.entryList, b.entryMap);

                if (!entryid) {
                  this.props.history.push(
                    window.rootDirectroy +
                    "/team/app/" +
                    id +
                    `/${dd.type}/${dd.entryId}`
                  );
                  // return;
                }
                entryid = entryid || dd.entryId;
                type = type || dd.type;
              }
            }
            let apps = [
              ...this.state.apps,
              ...this.state.dockItem,
              ...standardAppData,
            ];
            apps.map((res) => {
              res.apps.map((val) => {
                if (val._id === id) {
                  this.setState(
                    {
                      editable: val.editable,
                      dock: val.dock,
                      deletable: val.deletable,
                      copyable: val.copyable,
                      showContent: !0,
                      emptyCont: !1,
                      isAppEmpty: false,
                      isFlow: b.isFlow,
                      isOwner: b.isOwner,
                      entryMap: b.entryMap,
                      entryList: b.entryList,
                      titleName: b.name,
                      style: val.style,
                      appName: b.name,
                      appType: val.appType,
                      treeNodes: this._sortEntryList(b.entryList, b.entryMap),
                      entryid: entryid,
                      appid: id,
                      type: type,
                      isLoading: false,
                      flowMenuExpand: false,
                    },
                    () => {
                      this._initEntrySort();
                      this.initTreescrollTop();
                    }
                  );
                }
                return null;
              });
              return null;
            });
            if (b.virtually_contacts_setting) {
              this.openVirtualAddressBook(true);
            }
            this.setState({
              isLoading: false,
            });
          })
          .catch((res) => {
            console.log(res);
            if (res.data) {
              this.setState({
                emptyCont: !0,
                emptyTip: res.data.msg,
                isLoading: false,
              });
            }
          });
      }
    );
  };

  componentDidMount() {
    const appNewList = BsyUtils.Store.get("appNewList") || [];
    BsyUtils.Store.set(
      "appNewList",
      appNewList.filter((res) => res !== this.state.appid)
    );

    if(this.props.match.path === "/team/u/:id") {
      this.loadAppList(window.FX.STATIC.APPID);
    } else {
      this.loadAppList(this.state.appid, this.state.entryid, this.state.type);
    }
  }

  _getClosestEntryData = (e) => {
    const { entryMap } = this.state;
    if (e && e.length) {
      let t = entryMap[e.parent().parent().attr("data-id")],
        i = entryMap[e.prev().attr("data-id")],
        n = entryMap[e.attr("data-id")];
      return {
        target: n && n.entryId,
        before: i && i.entryId,
        parent: (t && t.entryId) || "root",
      };
    }
  };

  transformToTreeFormat = (b) => {
    let simpleData = {
      enable: true,
      idKey: "entryId",
      pIdKey: "parent",
    };
    var c,
      d,
      e = simpleData.idKey,
      f = simpleData.pIdKey,
      g = "children";
    if (!e || "" === e || !b) return [];
    if (Array.isArray(b)) {
      var h = [],
        i = [];
      for (c = 0, d = b.length; c < d; c++) {
        i[b[c][e]] = b[c];
      }

      for (c = 0, d = b.length; c < d; c++) {
        if (i[b[c][f]] && b[c][e] !== b[c][f]) {
          i[b[c][f]][g] || (i[b[c][f]][g] = []);

          b[c].title = b[c].name;
          b[c].key = b[c].entryId;
          i[b[c][f]][g].push(b[c]);
        } else {
          b[c].title = b[c].name;
          b[c].key = b[c].entryId;
          h.push(b[c]);
        }
      }
      return h;
    }
    b.title = b.name;
    b.key = b.entryId;
    return [b];
  };

  createTreeMenuData = (data, levelChild, child) => {
    const { entryMap, entryid, expandedKeys } = this.state;
    let newData = {};
    if (!entryMap[data.id || data.entryId]) {
      return null;
    }
    BsyUtils.forEach(entryMap[data.id || data.entryId], (key, val) => {
      if (key === "icon") {
        return;
      }
      newData[key] = val;
    });
    newData.isLeaf = false;
    newData.title = <></>;
    if (newData.type === "group") {
      newData.levelChild = levelChild;
      newData.parentId = entryMap[data.id || data.entryId].parent;
      newData.key = data.id || data.entryId;
      // newData.title = entryMap[data.id || data.entryId].name;
      newData.iconClass =
        entryMap[data.id || data.entryId].iconClass ||
        entryMap[data.id || data.entryId].icon;
      newData.children = [];
      if (data.child && data.child.length > 0) {
        levelChild++;
        let newChlid = data.child.filter((string) => {
          return entryMap[string.id || string.entryId] && string;
        });
        newData.children = newChlid.map((res) => {
          return this.createTreeMenuData(res, levelChild, child);
        });
      }
    } else {
      if (newData.entryId === entryid) {
        let child = [];
        let p = entryMap[entryid].parent;
        if (p) {
          child.push(p);
        }
        for (let i = 1; i < levelChild; i++) {
          p = entryMap[p].parent;
          child.push(p);
        }
        this.setState({
          expandedKeys: [...child, ...expandedKeys],
          selectedKeys: entryid,
        });
      }
      newData.levelChild = levelChild;
      newData.key = data.id || data.entryId;
      // newData.title = entryMap[data.id || data.entryId].name;
      newData.iconClass =
        entryMap[data.id || data.entryId].iconClass ||
        entryMap[data.id || data.entryId].icon;
      newData.parentId = data.parent;
    }
    return newData;
  };

  _initEntrySort = () => {
    let arry = [];
    let child = [];
    let levelChild = 0;
    let newChlid = this.state.treeNodes.filter((string) => {
      return this.state.entryMap[string.id || string.entryId] && string;
    });
    let treeData = newChlid.map((res) => {
      return this.createTreeMenuData(res, levelChild, child);
    });
    BsyUtils.forEach(this.state.entryMap, (obj, val) => {
      arry.push(val);
    });
    this.transformToTreeFormat(arry);
    this.setState({ treeData: treeData });
  };

  _getEntryList = () => {
    let $ = window.$;
    const { entryMap } = this.state;
    let a = [],
      b = $(this.menuTree.current),
      c = b.children("li:not(.placeholder)");
    c &&
      c.length > 0 &&
      window.FX.Utils.forEach(c, function (b, c) {
        if (c) {
          let d = entryMap[$(c).attr("data-id")];
          if (!d || !d.entryId) {
            a = false;
            return !1;
          }
          a[b] = {
            id: d.entryId,
            child: [],
          };
          let e = $(c).children("ul").children("li");
          window.FX.Utils.forEach(e, function (c, d) {
            if (d) {
              let e = entryMap[$(d).attr("data-id")];
              if (!e || !e.entryId) {
                a = false;
                return !1;
              }

              a[b].child[c] = {
                id: e.entryId,
              };
            }
          });
          if (!a) {
            return !1;
          }

          if (d.type !== "group") {
            delete a[b].child;
          }
        }
      });
    return a;
  };

  _saveEntryList = (e, t, i) => {
    window.FX.Utils.ajax(
      {
        url: "/dashboard/app/" + window.FX.STATIC.APPID + "/entry/sort",
        data: e,
      },
      function (d) {
        t && t(d);
      },
      function () {
        i && i();
        return !1;
      }
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { appid, type, entryid } = nextProps?.match?.params || {};
    if (this.state.appid !== appid) {
      this.loadAppList(appid, entryid, type);
    } else {
      this.setState({
        appid: appid,
        entryid: entryid,
        type: type,
      });
    }
  }

  switchFlowMenu = (val) => {
    const { appid } = this.state;
    return () => {
      window.$(".bsy-frame-menu").find(".select").removeClass("select");
      window.$("#menu" + val.id).addClass("select");
      window.FX.FORMCACHE && window.FX.FORMCACHE.saveFormData();
      this.props.history.push(
        `${window.rootDirectroy}/team/app/${appid}/flow/${val.id}`
      );
      this.setState({ selectedKeys: 1 });
    };
  };

  initTreescrollTop = () => {
    setTimeout(() => {
      const treepos = BsyUtils.elemoffset(
        document.querySelector(".bsy-tree-map")
      ); //树菜单
      const itempos = BsyUtils.elemoffset(
        document.querySelector(
          ".bsy-tree-map .rc-tree .rc-tree-list .rc-tree-list-holder .rc-tree-list-holder-inner .rc-tree-treenode.rc-tree-treenode-selected"
        )
      ); //选中元素的位置
      if (document.querySelector(".bsy-tree-map")) {
        const dd = document.querySelector(".bsy-tree-map").offsetHeight;
        if (itempos) {
          let offsettop = document.querySelector(".bsy-tree-map").scrollTop; //要考虑不在起点的情况
          // console.log('scrollTop',document.querySelector('.bsy-menutree').scrollTop)
          // console.log('treepos',treepos.top)
          // console.log('itempos',itempos.top)

          //可见区域
          if (itempos.top - treepos.top > 0 && itempos.top - treepos.top < dd) {
            return;
          }

          //不可见区域
          if (dd <= itempos.top - treepos.top + 28 && offsettop === 0) {
            document.querySelector(".bsy-tree-map").scrollTop =
              itempos.top - treepos.top;
          } else {
            document.querySelector(".bsy-tree-map").scrollTop =
              offsettop + itempos.top - treepos.top;
          }
        }
      }
    }, 100);
  };

  toTarget = (val, editAuth, expanded) => {
    let { appid, expandedKeys, treeData } = this.state;
    if (val.type === "group") {
      if (expanded) {
        this.setState({ expandedKeys: expanded, treeData: treeData });
      } else {
        if (expandedKeys.indexOf(val.entryId) > -1) {
          expandedKeys.splice(expandedKeys.indexOf(val.entryId), 1);
        } else {
          expandedKeys.push(val.entryId);
        }
        this.setState({ expandedKeys: expandedKeys, treeData: treeData });
      }
    } else {
      this.initTreescrollTop();
      window.FX.FORMCACHE && window.FX.FORMCACHE.saveFormData();
      this.props.history.push({
        pathname: `${window.rootDirectroy}/team/app/${appid}/${val.type}/${val.entryId}`,
        state: {
          titleName: val.name + " - " + this.state.appName,
          editAuth: editAuth,
        },
      });
      this.setState({ selectedKeys: val.entryId });
    }
  };

  _refreshTodoCount = (id, entryId, cb) => {
    // #data
    const t = this;
    window.FX.Utils.dataAjax(
      {
        url: "/dashboard/app/" + id + "/workflow/flow_todo_count",
        data: {
          appid: id,
        },
      },
      function (e) {
        t.setState(
          {
            flowCount: e.count,
            flowMenuExpand:
              ["todo", "cc", "transactors", "create"].indexOf(entryId) > -1 ? true : e.count > 0 ? true : false,
          },
          () => {
            if (e.count === 0) cb && cb();
          }
        );
      }
    );
  };

  createForm = (a, f) => {
    const { entryMap } = this.state;
    let _this = this;

    let formnumber = 0;
    BsyUtils.forEach(entryMap, function (a1, b1) {
      if (b1.type === "form") {
        formnumber++;
      }
    });

    if (formnumber >= _this.formNumberMax) {
      tipAlert({
        type: "warning",
        msg: React.language("application.more.tip", {
          formNumberMax: _this.formNumberMax,
        }),
      });
      return;
    }

    BsyDialog({
      title: a
        ? React.language("app.edit.coopForm.create")
        : React.language("app.edit.flowForm.create"),
      height: 256,
      width: 390,
      noFooter: true,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return (
          <CreateForm
            onCreateBlankForm={() => {
              _this.createEntry("form", a, null, f);
            }}
            onCreateExcelForm={() => {
              new window.FX.ExcelImportPane({
                groupItems: _this._getEntryGroups(),
                // dialog: c,
                hasCoop: a,
                parent: f,
                onFinish: function (a) {
                  _this._createEntry("form", a, null, f);
                },
              });
            }}
          />
        );
      },
    });

    // let b = this,
    //   c = new window.FX.Dialog({
    //     type: "dialog",
    //     title: a
    //       ? React.language("app.edit.coopForm.create")
    //       : React.language("app.edit.flowForm.create"),
    //     autoClose: !1,
    //     headerHeight: 50,
    //     width: 390,
    //     height: 256,
    //     contentWidget: {
    //       rowSize: [146],
    //       colSize: [165, 165],
    //       // hgap: 60,
    //       // vgap: 40,
    //       padding: 30,
    //       items: [
    //         [
    //           $('<div class="excel-form-item form-blank"/>')
    //             .append($('<div class="blank-form"/>'))
    //             .append(
    //               $('<div class="form-label"/>').text(
    //                 a
    //                   ? React.language("app.edit.formCreate.empty")
    //                   : React.language("create.blank.flow.form")
    //               )
    //             )
    //             .click(function () {
    //               b.createEntry("form", a, null, f);
    //             }),
    //           $('<div class="excel-form-item right"/>')
    //             .append($('<div class="blank-excel"/>'))
    //             .append(
    //               $('<div class="form-label"/>').text(
    //                 React.language("app.edit.formCreate.excel")
    //               )
    //             )
    //             .click(function () {
    //               new window.FX.ExcelImportPane({
    //                 groupItems: b._getEntryGroups(),
    //                 dialog: c,
    //                 hasCoop: a,
    //                 parent: f,
    //                 onFinish: function (a) {
    //                   b._createEntry("form", a, null, f);
    //                 },
    //                 onClose: () => {
    //                   b.loadAppList(
    //                     b.state.appid,
    //                     b.state.entryid,
    //                     b.state.type
    //                   );
    //                 },
    //               });
    //             }),
    //         ],
    //       ],
    //     },
    //   });
    // c.show();
  };

  _getEntryGroups = () => {
    const { entryMap } = this.state;
    let a = [
      {
        value: "1",
        text: React.language("app.edit.group.empty"),
        selected: !0,
      },
    ];
    BsyUtils.forEach(entryMap, function (b, c) {
      "group" === c.type &&
        a.push({
          value: c.entryId,
          text: c.name,
        });
    });
    return a;
  };

  createEntry = (a, b, e, h) => {
    let c;
    let d = this;
    if ("report" === a) {
      c = React.language("dash.defaultName");
    } else {
      if ("form" === a) {
        if (b) {
          c = React.language("form.defaultName");
        } else {
          c = React.language("unnamed.flow.form");
        }
        if (e) {
          c = React.language("unnamed.event.form");
        }
      }
    }
    if (a === "dash") {
      c = React.language("unnamed.dash.report");
    } else if (a === "scenes") {
      c = React.language("unnamed.scenes.report");
    }

    axios
      .post("/dashboard/app/" + this.state.appid + "/entry/create", {
        type: a,
        name: c,
        hasCoop: b,
        isEvent: e,
        parent: h,
      })
      .then((res) => {
        d._createEntry(a, res.data.entry);
      });
  };

  _createEntry = (a, b) => {
    let c = b.entryId;
    window.FX.Utils.redirectTo(
      "/dashboard/app/" + window.FX.STATIC.APPID + "/" + a + "/" + c + "/edit"
    );
  };

  createReport = (a, g) => {
    let _this = this;

    BsyDialog({
      title: React.language("app.edit.dash.create"),
      height: 256,
      width: 390,
      noFooter: true,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return (
          <CreateDash
            onCreateDash={() => {
              _this.createEntry("dash", a, null, g);
            }}
            onCreateScenes={() => {
              _this.createEntry("scenes", a, null, g);
            }}
          />
        );
      },
    });
  };

  createGroup = (a) => {
    const _this = this;
    const { groupExpandedMap } = this.state;
    BsyAlertTextEdit({
      title: React.language("app.edit.group.create"),
      placeholder: React.language("app.edit.group.placeholder"),
      width: 350,
      onOk: (name) => {
        let result = {};
        if (
          !BsyUtils.checkValidateTitle(
            name,
            React.language("receipt.fullName"),
            result
          )
        ) {
          return false;
        }

        axios
          .post("/dashboard/app/" + this.state.appid + "/entry/create", {
            type: "group",
            name: name,
            parent: a,
          })
          .then(() => {
            groupExpandedMap[a] = true;
            _this.setState({ groupExpandedMap: groupExpandedMap });
            _this.loadAppList(
              _this.state.appid,
              _this.state.entryid,
              _this.state.type
            );
          });
      },
    });
  };

  createBtn = (event) => {
    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: (ref) => {
        return (
          <div className="createForm-menu t-createForm-menu">
            <div
              className="createItem"
              onClick={() => {
                this.createForm(!0);
                ref.closeAlter();
              }}
            >
              <i className="icon-bsy-new-file" />
              <span>{React.language("app.edit.coopForm.create")}</span>
            </div>
            <div
              className="createItem"
              onClick={() => {
                this.createForm(!1);
                ref.closeAlter();
              }}
            >
              <i className="icon-form-flow" />
              <span>{React.language("app.edit.flowForm.create")}</span>
            </div>
            <div
              className="createItem"
              onClick={() => {
                this.createReport(!1);
                ref.closeAlter();
              }}
            >
              <i className="icon-bsy-new-report" />
              <span>{React.language("app.edit.dash.create")}</span>
            </div>
            <div className="line" />
            <div
              className="createItem"
              onClick={() => {
                this.createGroup();
                ref.closeAlter();
              }}
            >
              <i className="icon-create-group green" />
              <span>{React.language("app.creategroup")}</span>
            </div>
          </div>
        );
      },
      text4Cancel: null,
      text4Ok: null,
      minWidth: "auto",
      width: 206,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "right",
      // "marginTop":20,
      onClose: function () {
        return !1;
      },
    });
  };

  createEvent = (appType, editAuth) => {
    new window.FX.Slider({
      title: React.language("etl"),
      contentWidget: {
        type: "appetlpane",
        appType: appType,
        editAuth: editAuth,
      },
      onClose: function () { },
    }).show();
  };

  appSetting = (appType, editAuth) => {
    // window.FX.Utils.dt(window.FX.CONST.TRACKER.APP_CONFIG);
    // window.FX.STATIC.entryConfig.appType = window.FX.STATIC.APPTYPE;
    new window.FX.Slider({
      title: React.language("app.set"),
      contentWidget: {
        type: "appsetpane",
        appType: appType,
        editAuth: editAuth,
      },
      onClose: function () {
        window.FX.STATIC.design = false;
        window.times && clearTimeout(window.times);
      },
    }).show();
  };
  restoreEntry1 = (a, c, cd) => {
    const b = this;
    const FX = window.FX;
    FX.Utils.ajax(
      {
        url: "/dashboard/app/" + FX.STATIC.APPID + "/entry/" + a + "/restore",
      },
      function () {
        b.state.entryMap[a] = c;
        b.state.treeNodes.push({
          id: a,
        });
        b.setState({
          treeNodes: b.state.treeNodes,
          entryMap: b.state.entryMap,
        });

        tipAlert({
          type: "success",
          msg: React.language("successfully.restored.form"),
        });
        cd && cd();
      },
      function (a) {
        var c = a.responseJSON || {};
        tipAlert({
          type: "error",
          msg: c.msg || React.language("failed.restored.form"),
        });
        cd && cd();
      }
    );
  };
  restoreEntry = (a, c) => {
    return (event) => {
      const e = event.currentTarget;
      const b = this;
      const FX = window.FX;
      FX.Utils.ajax(
        {
          url: "/dashboard/app/" + FX.STATIC.APPID + "/entry/" + a + "/restore",
        },
        function () {
          b.state.entryMap[a] = c;
          b.state.treeNodes.push({
            id: a,
          });
          b.setState({
            treeNodes: b.state.treeNodes,
            entryMap: b.state.entryMap,
          });
          window.$(e).parent().parent().parent().remove();
          tipAlert({
            type: "success",
            msg: React.language("successfully.restored.form"),
          });
        },
        function (a) {
          var c = a.responseJSON || {};
          tipAlert({
            type: "error",
            msg: c.msg || React.language("failed.restored.form"),
          });
        }
      );
    };
  };

  recyclePane = () => {
    BsyDialog({
      title: React.language("form.recycle.bin"),
      height: 480,
      width: 680,
      noFooter: true,
      onContentCreate: () => {
        return <BsyRecyclePane restoreEntry={this.restoreEntry1} />;
      },
    });
  };

  _appEditStyle = (renderEl, data, g, e) => {
    g.closest(".bby-msg-bubble").remove();
    e.classList.add("select");
    const _this = this;
    const { entryMap } = this.state;
    const $ = window.$;
    let icons = [
      25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42,
      43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
    ];
    let curre_val = {
      icon: data.iconClass === undefined ? 0 : data.iconClass,
    };
    let menuClass = data.type;

    if (data.hasFlow) {
      menuClass = menuClass + "-flow";
    }

    let icon = $('<ul class="menu-pane-icon"/>').addClass(menuClass);
    window.FX.Utils.forEach(icons, function (a1, b1) {
      icon.append(
        $('<li class="menu-item"  />')
          .attr("role", b1)
          .addClass(data.iconClass === b1 ? "selected" : "")
          .append("<i class=' icon-new-bsy-form-" + b1 + "' >")
      );
    });
    let style_list = $('<div class="bsy-form-style-pane"/>');
    style_list.append(icon);

    window.FX.Msg.bubble({
      anchor: renderEl,
      contentHTML: style_list,
      text4Cancel: null,
      text4Ok: null,
      minWidth: 130,
      dockPosition: "left",
      contentPadding: 0,
      edge: 275,
      onClose: function () {
        window.FX.Utils.ajax(
          {
            url:
              "/dashboard/app/" +
              window.FX.STATIC.APPID +
              "/entry/" +
              data.entryId +
              "/update",
            data: curre_val,
          },
          function (d) {
            if (d.code === 3007) {
              tipAlert({
                type: "warning",
                msg: React.language(d.msg) || React.language("error.201"),
              });
            }
          },
          function (a) {
            let c = a.responseJSON || {};
            tipAlert({
              type: "error",
              msg: React.language(c.msg) || React.language("error.201"),
            });
          },
          function () { }
        );
        e.classList.remove("select");
        return !1;
      },
    });
    icon.bind("click", function (f) {
      let g = $(f.target).closest(".menu-item");
      let h = g.attr("role");
      if (h !== undefined) {
        icon.children(".menu-item").removeClass("selected");
        g.addClass("selected");
        curre_val.icon = h;
        data.iconClass = h;
        entryMap[data.entryId] = data;
        _this.setState({ entryMap });
      }
    });
  };

  _hideEntry = (a, b, c, d, g, r) => {
    let e = this,
      f = "";
    const { appid } = this.state;
    r.classList.add("select");
    const $ = window.$;
    let t = d;
    switch (d) {
      case "group":
        f = React.language("group");
        break;
      case "form":
        f = React.language("form");
        break;
      case "report":
      case "dash":
      case "scenes":
        t = "dash";
        f = React.language("dash");
        break;
      default:
    }
    // BsyAlert({
    //     title: React.language("confirm.delete.the", { name: (f + '-' + g.name) }),
    //     type: "warning",
    //     text4Ok: React.language("delete"),
    //     OkType: "red",
    //     bottomLeftTip: "",
    //     text4Cancel: React.language("cancel"),
    //     ok: () => {
    //         switch (d) {
    //             case "group":
    //                 e.removeGroup(a, c, g);
    //                 break;
    //             case "form":
    //             case "report":
    //             case "dash":
    //             case "scenes":
    //                 e.hideEntry(a)
    //                 break
    //             default:
    //         }
    //     }
    // })
    React.axios("/data/form_remove_check", {
      appId: appid,
      formId: a,
    }).then((res) => {
      const { is_referred } = res.data;
      window.FX.Msg.bubble({
        anchor: c,
        // hAdjust:16,
        contentHTML: $('<div style="width: 210px"></div>')
          .append(
            $('<div class="text-title"></div>').text(
              React.language("confirm.delete.the", { name: f + "-" + g.name })
            )
          )
          .append(
            is_referred
              ? $('<div class="relationship-btn"></div>')
                .on("click", function () {
                  e.openReferencePane(appid, a, t);
                })
                .text(React.language("view.reference.detail"))
              : ""
          ),
        dockPosition: "left",
        type: "error",
        text4Ok: React.language("delete"),
        onOk: function () {
          switch (d) {
            case "group":
              e.removeGroup(a, c, g);
              break;
            case "form":
            case "report":
            case "dash":
            case "scenes":
              e.hideEntry(a);
              break;
            default:
          }
          r.classList.remove("select");
        },
        onClose: function () {
          c.removeClass("show");
          r.classList.remove("select");
          return !1;
        },
      });
    });
  };

  openReferencePane = (a, b, t) => {
    BsySlidePane({
      title: React.language("reference.relationship"),
      hasHeader: true,
      onContentCreate: () => {
        return <BsyRelationshipForm appId={a} entryId={b} formType={t} />;
      },
    });
  };

  removeGroup = (a, c, g) => {
    if (g.children && g.children.length > 0) {
      tipAlert({
        type: "warning",
        msg: React.language("app.edit.group.deleteTip"),
      });
    } else {
      this.removeEntry(a);
    }
  };

  removeEntry = (a, cb) => {
    let b = this;
    const FX = window.FX;
    FX.Utils.ajax(
      {
        url: "/dashboard/app/" + FX.STATIC.APPID + "/entry/" + a + "/remove",
      },
      function () {
        delete b.state.entryMap[a];
        b._initEntrySort();
        b.setState({
          entryMap: b.state.entryMap,
        });
        if (cb) cb("success");
        else {
          tipAlert({
            type: "success",
            msg: React.language("delete.success"),
          });
        }
        // cb && cb("success");
      },
      function (a) {
        var c = a.responseJSON || {};
        tipAlert({
          type: "error",
          msg: c.msg || React.language("delete.fail"),
        });
        cb && cb("error");
      }
    );
  };

  hideEntry = (a) => {
    let b = this;
    const { entryid } = this.state;
    window.FX.Utils.ajax(
      {
        url:
          "/dashboard/app/" + window.FX.STATIC.APPID + "/entry/" + a + "/hide",
      },
      function () {
        delete b.state.entryMap[a];

        if (entryid === a) {
          window.location.href = `${window.rootDirectroy}/team/app/${window.FX.STATIC.APPID}`;
          return;
        }

        b.loadAppList(b.state.appid, b.state.entryid, b.state.type);
        tipAlert({
          type: "success",
          msg: React.language("operationSuccess"),
        });
      },
      function (a) {
        var c = a.responseJSON || {};
        tipAlert({
          type: "error",
          msg: c.msg || React.language("operationFailed"),
        });
      }
    );
  };

  _changeFormType = (a, b, e) => {
    const FX = window.FX;
    const _this = this;
    const { entryMap } = this.state;
    e.classList.add("select");
    let c = React.language("app.edit.toFlowForm.msg"),
      d = {
        hasCoop: !b.hasCoop,
      };
    if (!b.hasCoop) {
      c = React.language("app.edit.toCoopForm.msg");
      d.hasFlow = !1;
    }
    FX.Msg.alert({
      type: "warning",
      title: b.hasCoop
        ? React.language("app.edit.toFlowForm")
        : React.language("app.edit.toCoopForm"),
      msg: c,
      onOk: function () {
        FX.Utils.ajax(
          {
            url:
              "/dashboard/app/" +
              FX.STATIC.APPID +
              "/entry/" +
              b.entryId +
              "/update",
            data: d,
          },
          function () {
            b.hasCoop = !b.hasCoop;
            entryMap[b.entryId] = b;
            _this.setState({ entryMap });
            tipAlert({
              type: "success",
              msg: React.language("app.edit.change.success"),
            });
            e.classList.remove("select");
          }
        );
      },
      onCancel: function () {
        e.classList.remove("select");
      },
    });
  };

  _fetchAppList = (e) => {
    const t = this;
    const FX = window.FX;
    this.appList
      ? e && e(this.appList)
      : FX.Utils.ajax(
        {
          url: "/dashboard/app/" + FX.STATIC.APPID + "/ref_apps",
        },
        function (i) {
          t.appList = i.apps;
          e && e(t.appList);
        }
      );
  };

  _copyToEntry = (a, toappid) => {
    const FX = window.FX;
    const $ = window.$;
    FX.Utils.ajax(
      {
        url: "/dashboard/app/" + FX.STATIC.APPID + "/entry/" + a + "/copyto",
        data: toappid,
      },
      function () {
        tipAlert({
          type: "success",
          msg: React.language("app.edit.copy.success"),
        });
        $(".x-window-mask").remove();
      },
      function (a) {
        var b = a.responseJSON || {};
        tipAlert({
          type: "error",
          msg: b.msg || React.language("app.edit.copy.fail"),
        });
        $(".x-window-mask").remove();
      }
    );
  };

  _getApps = (t, r) => {
    let i = this,
      n = window.$('<div class="app-ref-copy-content">');
    r.classList.add("select");
    const FX = window.FX;
    this._fetchAppList(function (e) {
      var a = new FX.EntryAppRefCopy({
        renderEl: n,
        appList: e,
      });
      i.copyDialog = new FX.ConfirmDialog({
        title: React.language("app.edit.copyToOther"),
        width: 450,
        height: 430,
        onContentCreate: function (e) {
          e.append(n);
        },
        onOk: function () {
          let toappid = a.getValue();
          i._copyToEntry(t.entryId, toappid);
          r.classList.remove("select");
        },
        onCancel: function () {
          r.classList.remove("select");
          i.copyDialog.close();
        },
      });
      i.copyDialog.show();
    });
  };

  _changeFormEventType = (a, b, r) => {
    r.classList.add("select");
    const FX = window.FX;
    let c = React.language("switch.form.type.tip"),
      d = {
        isEvent: !b.isEvent,
      };
    b.isEvent || (c = React.language("switch.form.type.tip1"));
    FX.Msg.alert({
      type: "warning",
      title: a,
      msg: c,
      onOk: function () {
        FX.Utils.ajax(
          {
            url:
              "/dashboard/app/" +
              FX.STATIC.APPID +
              "/entry/" +
              b.entryId +
              "/update",
            data: d,
          },
          function () {
            b.isEvent = !b.isEvent;
            r.classList.remove("select");
          }
        );
      },
      onCancel: function () {
        r.classList.remove("select");
      },
    });
  };

  _copyEntry = (a, b, c1, r) => {
    r.classList.add("select");
    const FX = window.FX;
    const _this = this;
    const { entryList } = this.state;
    let formnumber = 0;
    FX.Utils.forEach(entryList, function (a1, b1) {
      if (b1.type !== "group") {
        formnumber++;
      }
    });

    if (formnumber > _this.formNumberMax) {
      tipAlert({
        type: "warning",
        msg: React.language("application.exceed", {
          formNumberMax: _this.formNumberMax,
        }),
      });
      return;
    }

    var c = this;
    FX.Utils.ajax(
      {
        url: "/dashboard/app/" + FX.STATIC.APPID + "/entry/" + a + "/copy",
      },
      function () {
        tipAlert({
          type: "success",
          msg: React.language("app.edit.copy.success"),
        });
        // c.state.entryMap[a.entry.entryId] = a.entry;
        // c.state.entryMap[a.entry.entryId].icon = c1.icon;
        // c.state.entryMap[a.entry.entryId].hasCoop = c1.hasCoop;
        // c.state.entryMap[a.entry.entryId].hasFlow = c1.hasFlow;
        // c.state.entryMap[a.entry.entryId].isEvent = c1.isEvent;
        // if (a.entry.parent !== "1") {
        //     c.state.treeNodes.map((res) => {
        //         if (res.id === a.entry.parent) {
        //             res.child.push({
        //                 id: a.entry.entryId
        //             })
        //         }
        //     })
        // } else {
        //     c.state.treeNodes.push({
        //         id: a.entry.entryId
        //     })
        // }
        c.loadAppList(c.state.appid, c.state.entryid, c.state.type);
        r.classList.remove("select");
      },
      function (a) {
        var b = a.responseJSON || {};
        tipAlert({
          type: "error",
          msg: b.msg || React.language("app.edit.copy.fail"),
        });
        r.classList.remove("select");
      }
    );
  };

  _editName = (a, b, c, d, e) => {
    const _this = this;
    const { treeData } = this.state;
    e.classList.add("select");
    var formtype = React.language("form");
    if (d.type === "report" || d.type === "dash" || d.type === "scenes") {
      formtype = React.language("dash");
    } else if (d.type === "group") {
      formtype = React.language("group");
    }
    BsyAlertTextEdit({
      title:
        React.language("modify") +
        formtype +
        React.language("receipt.fullName"),
      placeholder:
        React.language("please.enter") +
        formtype +
        React.language("receipt.fullName"),
      value: d.name,
      width: 350,
      onOk: (name) => {
        let result = {};
        if (
          !BsyUtils.checkValidateTitle(
            name,
            React.language("receipt.fullName"),
            result
          )
        ) {
          return false;
        }
        window.FX.Utils.ajax(
          {
            url:
              "/dashboard/app/" +
              window.FX.STATIC.APPID +
              "/entry/" +
              a +
              "/update",
            data: {
              name: name,
            },
          },
          function () {
            _this.state.entryMap[a].name = name;
            _this.state.entryMap[a].title = name;
            _this.state.entryMap[a].text = name;
            _this._initEntrySort();
            _this.setState({
              entryMap: _this.state.entryMap,
            });
          }
        );
        e.classList.remove("select");
      },
      onCancel: () => {
        e.classList.remove("select");
      },
    });
  };

  favorite = (data, status) => {
    const { appid } = this.state;
    // 直接更新状态，不等后端返回
    this.setState(
      {
        entryMap: {
          ...this.state.entryMap,
          [data.entryId]: {
            ...this.state.entryMap[data.entryId],
            isFavorite: !status,
          },
        },
      },
      () => {
        this._initEntrySort();
      }
    );
    React.axios(
      !status ? "/dashboard/favorite_add" : "/dashboard/favorite_remove",
      {
        favorites: [
          {
            type: "entry",
            appId: appid,
            entryId: data.entryId,
          },
        ],
      }
    ).then((res) => {
      const { data: resData } = res;
      if (resData.code === 200) {
        this.setState(
          {
            entryMap: {
              ...this.state.entryMap,
              [data.entryId]: {
                ...this.state.entryMap[data.entryId],
                isFavorite: !status,
              },
            },
          },
          () => {
            this._initEntrySort();
          }
        );
      } else if (resData.code === 400) {
        tipAlert({
          type: "error",
          msg: resData.msg || React.language("error.201"),
        });
      }
    });
  };

  formBtnEdit = (a, b, c, r, e, isHasChild) => {
    return (f) => {
      let g = window.$(f.target).closest(".menu-item"),
        h = g.attr("data-role");
      window.FX.UI.closePopover();
      const d = this;
      if (h) {
        r.closeAlter();
        switch (h) {
          case "favorite":
            d.favorite(c, c.isFavorite);
            break;
          case "editstyle":
            d._appEditStyle(b, c, a, e);
            break;
          case "edit":
            d._editName(c.entryId, a, b, c, e);
            break;
          case "delete":
            d._hideEntry(c.entryId, a, b, c.type, c, e);
            break;
          case "coop":
            d._changeFormType(a, c, e);
            break;
          case "copyto":
            d._getApps(c, e);
            break;
          case "event":
            d._changeFormEventType(g.text(), c, e);
            break;
          case "copy":
            d._copyEntry(c.entryId, a, c, e);
            break;
          case "move":
            !isHasChild && d._moveEntry(c.entryId, a, c, e);
            break;
          case "createForm":
            d.createForm(!0, c.entryId, a, c._id, e);
            break;
          case "createFlowForm":
            d.createForm(!1, c.entryId, a, c._id, e);
            break;
          case "createDash":
            d.createReport(!1, c.entryId, a, c._id, e);
            break;
          case "createGroup":
            d.createGroup(c.entryId, a, c._id, e);
            break;
          default:
        }
      }
    };
  };

  _moveEntry = (a, b, c) => {
    // const { apps, dockItem } = this.props;
    const { entryList, apps, dockItem } = this.state;
    let currentApp;
    apps.map((res) => {
      res.apps.map((res1) => {
        if (res1._id === this.state.appid) {
          currentApp = res1;
        }
        return null;
      });
      return null;
    });
    dockItem.map((res) => {
      res.apps.map((res1) => {
        if (res1._id === this.state.appid) {
          currentApp = res1;
        }
        return null;
      });
      return null;
    });
    BsyDialog({
      title: React.language("move"),
      height: 580,
      width: 680,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return (
          <BsySelectFormGroup
            currentApp={currentApp}
            current={c}
            {...this.state}
            appid={"root"}
            getSelectFormGroupId={this.getSelectFormGroupId}
          />
        );
      },
      onOk: () => {
        this._saveEntryList(
          {
            before:
              entryList.length > 0 && this.selectFormGroupId === "root"
                ? entryList[entryList.length - 1].id !== c.entryId
                  ? entryList[entryList.length - 1].id
                  : undefined
                : undefined,
            target: c.entryId,
            parent: this.selectFormGroupId,
          },
          (d) => {
            this.setState(
              {
                treeNodes: this._sortEntryList(d.entryList, d.entryMap),
                entryMap: d.entryMap,
                entryList: d.entryList,
              },
              () => {
                this._initEntrySort();
              }
            );
          }
        );
      },
    });
  };

  getSelectFormGroupId = (ref) => {
    this.selectFormGroupId = ref;
  };

  isHasChild = (isHasChild, childNode) => {
    const { entryMap } = this.state;
    let i = entryMap[childNode.id];
    if (i && i.type === "group") {
      isHasChild = true;
    }
    childNode.child &&
      BsyUtils.forEach(childNode.child, (obj, val) => {
        this.isHasChild(isHasChild, val);
      });
  };

  createFormDashMenu = (val) => {
    const { appid, editable, deletable, copyable, dock } = this.state;
    const editAuth =
      BsyUtils.hasTokenEdit(appid) ||
      ((window.FX.STATIC["user_corps"].isSysManager ||
        editable ||
        deletable ||
        copyable) &&
        !dock);

    return (event) => {
      event.stopPropagation();
      const e = event.currentTarget;
      e.classList.add("select");
      let f = React.language("app.edit.toCoopForm");
      let g = React.language("switch.event.form");
      val.hasCoop && (f = React.language("app.edit.toFlowForm"));
      val.isEvent && (g = React.language("switch.notEvent.form"));
      let isForm = val.type === "form";
      let isReport =
        val.type === "report" || val.type === "dash" || val.type === "scenes";
      let isGroup = val.type === "group";
      let isHasChild = false;

      val.children &&
        BsyUtils.forEach(val.children, (obj, val) => {
          if (val.type === "group") {
            isHasChild = true;
          }
        });
      console.log(isHasChild);
      BsyMsgBubble({
        anchor: e,
        contentHTML: (ref) => {
          if (!editAuth) {
            return (
              <div
                className="editForm-menu"
                onClick={this.formBtnEdit(
                  window.$(event.currentTarget.parentNode),
                  window.$(event.currentTarget),
                  val,
                  ref,
                  e,
                  isHasChild
                )}
              >
                {isGroup ? (
                  ""
                ) : (
                  <li className="menu-item" data-role="favorite">
                    {val.isFavorite ? (
                      <i
                        className="icon-bsy-favorite"
                        style={{
                          color: "#333",
                        }}
                      />
                    ) : (
                      <i
                        className="icon-new-shoucangxianxing"
                        style={{
                          color: "#333",
                        }}
                      />
                    )}

                    <span>
                      {val.isFavorite
                        ? React.language("app.favorites.cancel")
                        : React.language("app.favorites.tip")}
                    </span>
                  </li>
                )}
              </div>
            );
          }

          return (
            <div
              className="editForm-menu"
              onClick={this.formBtnEdit(
                window.$(event.currentTarget.parentNode),
                window.$(event.currentTarget),
                val,
                ref,
                e,
                isHasChild
              )}
            >
              {(isForm || isReport) && (
                <li className="menu-item" data-role="editstyle">
                  <i className="icon-bsy-iconyangshi" />
                  <span>{React.language("app.style.edit")}</span>
                </li>
              )}

              {(isForm || isReport || isGroup) && (
                <li className="menu-item" data-role="edit">
                  <i className="icon-bsy-iconxiugai" />
                  <span>{React.language("name.update")}</span>
                </li>
              )}
              {!isGroup && (
                <li className="menu-item" data-role="favorite">
                  <i
                    className={
                      val.isFavorite
                        ? "icon-bsy-favorite"
                        : "icon-new-shoucangxianxing"
                    }
                    style={{
                      color: val.isFavorite ? "#FFC502" : "#333",
                    }}
                  />
                  <span>
                    {val.isFavorite
                      ? React.language("app.favorites.cancel")
                      : React.language("app.favorites.tip")}
                  </span>
                </li>
              )}
              {
                <div
                  className={"menu-item" + (isHasChild ? " hasChild" : "")}
                  data-role="move"
                  onMouseEnter={(event) => {
                    if (isHasChild) {
                      window.FX.UI.showPopover({
                        position: "rightTopBaseline",
                        anchor: window.$(event.target),
                        content: window
                          .$("<span/>")
                          .text(React.language("app.edit.move.tip")),
                        type: "dark",
                      });
                    }
                  }}
                  onMouseLeave={() => {
                    isHasChild && window.FX.UI.closePopover();
                  }}
                >
                  <i className="icon-bsy-drag" />
                  <span>{React.language("move")}</span>
                </div>
              }
              {(isReport || isGroup) && <div className="line" />}

              {val.type === "group" && (
                <div className="menu-item" data-role="createForm">
                  <i className="icon-bsy-new-file"></i>
                  <span>{React.language("app.edit.coopForm.create")}</span>
                </div>
              )}

              {val.type === "group" && (
                <div className="menu-item" data-role="createFlowForm">
                  <i className="icon-form-flow"></i>
                  <span>{React.language("app.edit.flowForm.create")}</span>
                </div>
              )}

              {val.type === "group" && (
                <div className="menu-item" data-role="createDash">
                  <i className="icon-bsy-new-report"></i>
                  <span>{React.language("app.edit.dash.create")}</span>
                </div>
              )}

              {val.type === "group" && val.levelChild < 1 && (
                <div className={"menu-item"} data-role="createGroup">
                  <i className="icon-create-group"></i>
                  <span>{React.language("app.edit.child.group.create")}</span>
                </div>
              )}

              {isForm && (
                <li className="menu-item" data-role="coop">
                  <i className="icon-bsy-iconqiehuan" />
                  <span>{f}</span>
                </li>
              )}
              {isForm && (
                <li className="menu-item" data-role="event">
                  <i className="icon-bsy-iconqiehuan" />
                  <span>{g}</span>
                </li>
              )}
              {isForm && <div className="line" />}
              {(isForm || isReport) && (
                <li className="menu-item" data-role="copy">
                  <i className="icon-bsy-iconfuzhi" />
                  <span>{React.language("app.edit.copyToCurrent")}</span>
                </li>
              )}
              {isForm && (
                <li className="menu-item" data-role="copyto">
                  <i className="icon-bsy-iconfuzhi" />
                  <span>{React.language("app.edit.copyToOther")}</span>
                </li>
              )}
              {isGroup && <div className="line" />}
              <li className="menu-item entry-remove" data-role="delete">
                <i className="icon-bsy-iconshanchu" />
                <span>{React.language("delete")}</span>
              </li>
            </div>
          );
        },
        text4Cancel: null,
        text4Ok: null,
        minWidth: 206,
        width: 206,
        contentPadding: 0,
        edge: 270,
        hAdjust: 72,
        dockPosition: "right",
        // "marginTop":20,
        onClose: function () {
          e.classList.remove("select");
          return !1;
        },
      });
    };
  };

  handleMoveNode = (node) => {
    const _this = this;
    let n = node.dragNode;
    let i = node.node;
    let hasChildGroup = false;
    if (n.type === "group" && n.children) {
      for (let i = 0; i < n.children.length; i++) {
        if (n.children[i].type === "group") {
          hasChildGroup = true;
        }
      }
    }

    let parent = i.levelChild === 0 ? "root" : i.parent;
    let before = i.entryId;
    if (i.expanded) {
      parent = i.entryId;
      before = null;
    }

    if (node.dropPosition < 0) {
      parent = "root";
      before = undefined;
    } else {
      if (
        n.type === "group" &&
        ((hasChildGroup && i.type === "group" && i.expanded) ||
          (hasChildGroup && i.levelChild > 0) ||
          (i.levelChild > 0 && i.type === "group" && i.expanded) ||
          i.levelChild > 1)
      ) {
        tipAlert({
          type: "warning",
          msg: React.language("max.two.level.group"),
        });
        return;
      }
    }
    let sortList = {
      target: n && n.entryId,
      before: before,
      parent: parent,
    };
    window.FX.Utils.ajax(
      {
        url: "/dashboard/app/" + window.FX.STATIC.APPID + "/entry/sort",
        data: sortList,
      },
      function (d) {
        _this.setState(
          {
            treeNodes: _this._sortEntryList(d.entryList, d.entryMap),
            entryMap: d.entryMap,
            entryList: d.entryList,
          },
          () => {
            _this._initEntrySort();
          }
        );
      },
      function () { }
    );
  };

  enteryListData = (val, items, treeNodes1, entryids) => {
    const { entryMap } = this.state;
    if (val.hasOwnProperty("child")) {
      let child = [];
      BsyUtils.forEach(val.child, (obj, val1) => {
        if (entryids.indexOf(val1.id) > -1) {
          return;
        }
        entryids.push(val1.id);
        items.push(entryMap[val1.id]);
        child.push({
          id: val1.id,
        });
        this.enteryListData(val1, items, treeNodes1, entryids);
      });
      treeNodes1.push({
        id: val.id,
        child: child,
      });
    } else {
      if (entryids.indexOf(val.id) > -1) {
        return;
      }
      entryids.push(val.id);
      items.push(entryMap[val.id]);
      treeNodes1.push({
        id: val.id,
      });
    }
  };

  newParentOverNode = null;
  startNode = null;

  openVirtualAddressBook = (auto) => {
    BsySlidePane({
      title: React.language("virtual.name.correspondence.settings"),
      hasHeader: true,
      hasCloseIcon: auto === true ? false : true,
      onContentCreate: (ref) => {
        return (
          <NameCorrespondenceSetting
            autoopen={auto}
            appId={this.state.appid}
            slideRef={ref}
          />
        );
      },
    });
  };

  hasEditAuth = () => {
    const { dock, appid, editable, deletable, copyable } = this.state;
    return (
      BsyUtils.hasTokenEdit(appid) ||
      ((window.FX.STATIC["user_corps"].isSysManager ||
        editable ||
        deletable ||
        copyable) &&
        !dock)
    );
  };

  hasDataView = () => {
    const { dock, appid } = this.state;

    return (
      this.hasEditAuth() ||
      BsyUtils.hasTokenEdit(appid) ||
      ((BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) && !dock)
    );
  };

  hasTrash = () => {
    const { appType, dock, appid } = this.state;

    return (
      this.hasEditAuth() ||
      BsyUtils.hasTokenEdit(appid) ||
      (appType === 4
        ? false
        : (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) && !dock)
    );
  };

  hasSetting = () => {
    const { dock, appid } = this.state;

    return (
      this.hasEditAuth() ||
      BsyUtils.hasTokenEdit(appid) ||
      ((BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) && !dock)
    );
  };

  hasVirtualAddressBook = () => {
    const { appType, dock, appid } = this.state;
    return (
      BsyUtils.hasTokenEdit(appid) ||
      (appType === 4 &&
        !dock &&
        (BsyUtils.isCorpOwn() ||
          BsyUtils.isSysManager() ||
          BsyUtils.isSubAdmin()))
    );
  };

  favoritesList = (cb) => {
    const { favoritesItems } = this.state;
    if (favoritesItems) {
      cb && cb(favoritesItems);
      return;
    }
    React.axios("/dashboard/favorites", {}).then((res) => {
      const { data: resData } = res;
      this.setState(
        {
          favoritesItems: resData.favorites,
        },
        () => {
          cb && cb(resData.favorites);
        }
      );
    });
  };

  openChangeApp = () => {
    const { apps, appid, favoritesItems } = this.state;
    let layerRef = null;
    BsyMaskLayer({
      customCls: "sloading",
      onMaskClick: (event) => {
        // if (event.target.classList.contains("BsyMaskLayer")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <BrowserRouter>
            <ChangeAppPane
              favoritesItems={favoritesItems}
              apps={apps}
              selectAppid={appid}
              onClose={() => {
                layerRef.close();
              }}
            />
          </BrowserRouter>
        );
      },
    });
  };

  _initHideMenu = () => {
    let b = this;
    const { type } = this.state;;
    this.body.current.classList.toggle("full-screen");

    setTimeout(() => {
      if (type === "dash" || type === "scenes") {
        if (b.Report) {
          b.Report.updateComponentsPos && b.Report.updateComponentsPos();
        }
        if (type === "dash" || type === "scenes") {
          b.contentContext?.bsyDashContext?.doResize();
        }
      }
    }, 300);

    // let $ = window.$;
    // if ($("i", $(event.currentTarget)).hasClass("bs-icon-iconcaidanshouqi")) {
    //   $(this.menu.current).animate({ width: 0, overflow: "hidden" }, 300);

    //   $(this.contentRef.current).animate({ left: 0 }, 300, function () {
    //     if (b.Report) {
    //       b.Report.updateComponentsPos && b.Report.updateComponentsPos();
    //     }
    //     if (b.type === "dash" || b.type === "scenes") {
    //       b.bsyDashContext && b.bsyDashContext.doResize();
    //     }
    //   });

    //   $("i", $(event.currentTarget)).addClass("bs-icon-iconcaidanzhankai");
    //   $("i", $(event.currentTarget)).removeClass("bs-icon-iconcaidanshouqi");
    // } else {
    //   $("i", $(event.currentTarget)).addClass("bs-icon-iconcaidanshouqi");
    //   $("i", $(event.currentTarget)).removeClass("bs-icon-iconcaidanzhankai");
    //   $(this.contentRef.current).animate({ left: 280 }, 300, function () {
    //     if (b.Report) {
    //       b.Report.updateComponentsPos && b.Report.updateComponentsPos();
    //     }
    //     if (b.type === "dash" || b.type === "scenes") {
    //       b.bsyDashContext && b.bsyDashContext.doResize();
    //     }
    //   });
    //   $(this.menu.current).animate({ width: 280, overflow: "" }, 300);
    // }
  };

  switchVirtualType = (t) => {
    return () => {
      this.setState({ virtualType: t }, () => {
        // this.props.switchVirtualType && this.props.switchVirtualType(t)
      });
    };
  };

  render() {
    const {
      appType,
      isEnter,
      treeNodes,
      virtualType,
      expandedKeys,
      selectedKeys,
      style,
      flowMenuExpand,
      isFlow,
      entryMap,
      emptyCont,
      emptyTip,
      entryid,
      type,
      showContent,
      flowCount,
      editable,
      appName,
      appid,
      dock,
      treeData,
      isAppEmpty,
      notFoundApp,
    } = this.state;

    if (notFoundApp) {
      // document.title = React.language("app.notFound");
      return (
        <ErrorComponent
          errorMsg={React.language("app.notFound")}
          goHome={true}
        />
      );
    }

    const items = [];
    const entryids = [];
    const treeNodes1 = [];
    const newExpandedKeys = [...new Set(expandedKeys)];
    const editAuth = this.hasEditAuth();

    treeNodes.forEach((val) => {
      this.enteryListData(val, items, treeNodes1, entryids);
    });

    let hideIcon = 0;
    if (this.hasTrash()) {
      hideIcon++;
    }
    if (this.hasDataView()) {
      hideIcon++;
    }
    if (this.hasSetting()) {
      hideIcon++;
    }
    if (this.hasVirtualAddressBook()) {
      hideIcon++;
    }
    setPageTitle(appType === 3 && virtualType === 2
      ? React.language("virtual.address.book") + " - " + appName
      : appName || "");
    return (

      <div
        key={appid}
        className={`BsyDashboardApp ${appType === 3 ? "standard" : ""}`}>
        {!isAppEmpty && (
          <>
            {appType === 3 ? (
              <div className="standard-app-menu">
                <div className="standard-app-menu-left">
                  {
                    <BsySystemLeftMenu
                      homeIcon={() => {
                        return <i className="icon-bsy-left"></i>;
                      }}
                      homeLink={"/team/standard"}
                      backTitle={React.language("standard.application")}
                      onRenderTitle={() => (
                        <div
                          className="left-title"
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div
                            className="icon-wrapper"
                            style={{
                              width: 26,
                              height: 26,
                              marginRight: 10,
                              borderRadius: 4,
                              overflow: "hidden",
                            }}
                          >
                            <div
                              className={`icon-backgroup color-cover-${style?.color}`}
                              style={{
                                height: "100%",
                              }}
                            >
                              <div
                                className={`imgbg-bsy-app imgbg-bsy-app-${style?.icon}`}
                              ></div>
                            </div>
                          </div>
                          <div className="app-title" title={appName}>
                            {appName}
                          </div>
                        </div>
                      )}
                    />
                  }
                </div>
                <div className="standard-app-menu-center">
                  <div className="virtual-menu">
                    <div
                      className={`menu-item ${virtualType === 1 ? "select" : ""
                        }`}
                      onClick={this.switchVirtualType(1)}
                    >
                      {React.language("test.app.edit")}
                    </div>
                    <div
                      className={`menu-item ${virtualType === 2 ? "select" : ""
                        }`}
                      onClick={this.switchVirtualType(2)}
                    >
                      {React.language("virtual.address.book")}
                    </div>
                  </div>
                </div>

                <BsySystemRightMenu search={false} />
              </div>
            ) : (
              ""
            )}
            <div className="bsy-frame-body" ref={this.body}>
              <div className="bsy-frame-content" ref={this.contentRef}>
                {showContent && entryid && type ? (
                  <Content
                    onGetContext={(context) => {
                      this.contentContext = context;
                    }}
                    editAuth={editAuth}
                    appName={appName}
                    entryMap={entryMap}
                    _initHideMenu={this._initHideMenu}
                    appId={appid}
                    entryId={entryid}
                    type={type}
                    appType={appType}
                  />
                ) : (
                  <>



                    {BsyUtils.hasTokenEdit(appid) || (editAuth && appType !== 4 && BsyUtils.isObjectEmpty(entryMap)) ? (
                      <div className="t-empty-new-add-app">
                        <section>
                          <p className="title">创建以下表单，开始创建应用</p>
                          <ul>
                            <li
                              onClick={() => {
                                this.createForm(!0);
                              }}
                            >
                              <img src={img_biaodan} alt="" />
                              <div className="ul-subheading">
                                <i className="icon-add-group add-from"></i>
                                <span className="ul-title">新建表单</span>
                              </div>
                              <div className="notic">
                                适用于数据提交、收集、问卷调研等业务。
                              </div>
                            </li>
                            <li
                              onClick={() => {
                                this.createForm(!1);
                              }}
                            >
                              <img src={img_liucheng} alt="" />
                              <div className="ul-subheading">
                                <i className="icon-add-group add-router-from"></i>
                                <span className="ul-title">新建流程表单</span>
                              </div>
                              <div className="notic">
                                适用于有流程审批，需要不同成员分步骤填写数据的业务
                              </div>
                            </li>
                            <li
                              onClick={() => {
                                this.createReport(!1);
                              }}
                            >
                              <img src={img_baobiao} alt="" />
                              <div className="ul-subheading">
                                <i className="icon-add-group add-dash"></i>
                                <span className="ul-title">新建报表</span>
                              </div>
                              <div className="notic">
                                适用于分析和展现流程表单、表单搜集到的数据。（建议在创建表单/流程表单后使用）
                              </div>
                            </li>
                          </ul>
                          <p className="tip">
                            请选择您要创建的表单类型，开启应用搭建
                          </p>
                        </section>
                      </div>
                    ) : ''}
                  </>
                )}
              </div>
              <div className="bsy-frame-menu" ref={this.menu}>
                <div
                  className="bsy-sidebar-container"
                  onClick={this._initHideMenu}
                >
                  <div className="icon-container">
                    <i
                      className={
                        // isExpand
                        //   ? "bs-icon-iconcaidanzhankai"
                        "bs-icon-iconcaidanshouqi"
                      }
                    />
                  </div>
                </div>
                {
                  <div className="bsy-frame-to-app">
                    <BsySystemLeftMenu
                      backTitle={React.language("dashboard")}
                      onRenderTitle={() => (
                        <div
                          className="left-title clickable"
                          onClick={() => {
                            this.favoritesList(() => {
                              this.openChangeApp();
                            });
                          }}
                        >
                          {appName}
                        </div>
                      )}
                    />
                  </div>
                }
                <div
                  className={"bsy-frame-search " + (isFlow ? "isFlow" : "")}
                  style={{ height: isFlow ? "" : "calc(100% - 16x)" }}
                >
                  <div
                    style={{
                      height: `calc(100% - ${editAuth || appType === 4 ? "79px" : "47px"
                        })`,
                    }}
                    className="bsy-frame-scroll"
                  >
                    <div
                      className={
                        "bsy-menutree " + (flowMenuExpand ? "expand" : "")
                      }
                    >
                      {!isFlow ? (
                        ""
                      ) : (
                        <>
                          <div
                            className="bsy-flow-menu-title"
                            onClick={() => {
                              let flownum = 0;
                              if (this.flownumref.current) {
                                flownum = parseInt(
                                  this.flownumref.current.innerHTML
                                );
                              }

                              this.setState({
                                flowMenuExpand: !flowMenuExpand,
                                flowCount: flownum,
                              });
                            }}
                          >
                            {/* <i className={`icon-form-new-flow`} /> */}
                            <span className="bsy-flow-title">
                              {React.language("flow.center")}
                            </span>
                            {!flowMenuExpand && flowCount !== 0 ? (
                              <span
                                className="tip flow-count error"
                                title={React.language("flow.todo.count", {
                                  count: flowCount,
                                })}
                              >
                                {flowCount}
                              </span>
                            ) : (
                              ""
                            )}
                            <i
                              className={
                                flowMenuExpand
                                  ? `icon-op icon-up1`
                                  : "icon-op icon-bsy-right"
                              }
                            />
                          </div>
                          <div
                            className={
                              "bsy-flow-menu " +
                              (flowMenuExpand ? "" : "hide")
                            }
                          >
                            {this.FlowMenuData.map((val) => {
                              return (
                                <div
                                  key={val.id + appid}
                                  id={"menu" + val.id}
                                  className={"menu-item " + val.id}
                                  onClick={this.switchFlowMenu(
                                    val,
                                    editAuth && appType !== 4
                                  )}
                                >
                                  <i className={"icon-new-bsy-" + val.id} />
                                  <span>{val.text}</span>
                                  {val.id === "todo" && flowCount !== 0 && (
                                    <span
                                      className="tip flow-count error"
                                      ref={this.flownumref}
                                      title={React.language(
                                        "flow.todo.count",
                                        { count: flowCount }
                                      )}
                                    >
                                      {flowCount}
                                    </span>
                                  )}
                                  {val.id === "cc" ? (
                                    <span className="tip min error"> </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              );
                            })}
                          </div>
                          {/* <div className="flow-split"></div> */}
                        </>
                      )}
                      {
                        <div className="bsy-tree-search">
                          <BsySearchResult
                            dockPosition="left"
                            items={items}
                            width={220}
                            autoClose={false}
                            height={"auto"}
                            placeholder={React.language("name.form.report")}
                            onCreatResult={(res) => {
                              let list = [];
                              for (let i = 0; i < res.length; i++) {
                                if (res[i].type !== "group") {
                                  list.push(res[i]);
                                }
                              }
                              return list.length > 0 ? (
                                <ul
                                  className="frame-search-entry"
                                  style={{
                                    maxHeight: 280,
                                    overflow: "auto",
                                    margin: 4,
                                  }}
                                >
                                  {list.map((val) => {
                                    return (
                                      val && (
                                        <li key={val._id + appid}>
                                          {
                                            <div
                                              className="menu-item"
                                              title={val.text}
                                              onClick={() => {
                                                this.toTarget(val, editAuth);
                                              }}
                                            >
                                              <i
                                                className={
                                                  val.type === "group"
                                                    ? `node-icon icon-bsy-folder-close`
                                                    : `node-icon icon-bsy-${val.type
                                                    }${!val.hasCoop
                                                      ? "-flow"
                                                      : ""
                                                    } ` +
                                                    ((val.iconClass ||
                                                      val.icon) <= 24
                                                      ? `icon-bsy-form-${val.iconClass ||
                                                      val.icon
                                                      }`
                                                      : `icon-new-bsy-form-${val.iconClass ||
                                                      val.icon
                                                      }`)
                                                }
                                              />
                                              <span
                                                dangerouslySetInnerHTML={{
                                                  __html: val.titleHtml,
                                                }}
                                              />
                                            </div>
                                          }
                                        </li>
                                      )
                                    );
                                  })}
                                </ul>
                              ) : (
                                <div className="emptySearch">
                                  {React.language("field.location.empty")}
                                </div>
                              );
                            }}
                          />
                          {BsyUtils.hasTokenEdit(appid) ||
                            (editAuth && appType !== 4 && (
                              <div className="bsy-frame-create">
                                <div
                                  className="circle-btn"
                                  onClick={this.createBtn}
                                >
                                  <i className="icon-bsy-add" />
                                </div>
                              </div>
                            ))}
                        </div>
                      }
                      <div
                        className="bsy-tree-map"
                        style={{
                          height: `calc(100% - ${isFlow ? "55px" : "13px"})`,
                        }}
                      >
                        <Tree
                          treeData={treeData}
                          isVirtualized={false}
                          defaultExpandedKeys={[1]}
                          expandedKeys={newExpandedKeys}
                          selectedKeys={[selectedKeys]}
                          onExpand={(expanded, node) => {
                            this.newParentOverNode = null;
                            if (isEnter) {
                              this.setState({ expandedKeys: expanded });
                            } else {
                              this.toTarget(
                                node.node,
                                BsyUtils.hasTokenEdit(appid) ||
                                (editAuth && appType !== 4),
                                expanded
                              );
                            }
                          }}
                          onDragEnter={(node) => {
                            this.setState({
                              expandedKeys: node.expandedKeys,
                            });
                          }}
                          draggable={
                            (window.FX.STATIC["user_corps"].isSysManager ||
                              editable) &&
                            !dock
                          }
                          onDragOver={(node) => {
                            let n = node.node;
                            if (!this.newParentOverNode) {
                              this.newParentOverNode = node;
                            }
                            if (node.dropPosition < 0) {
                              window.FX.UI.closePopover();
                              return;
                            }
                            if (this.newParentOverNode.node.key !== n.key) {
                              let i = this.startNode.node;
                              let hasChildGroup = false;

                              if (n.levelChild < 1) {
                                window.FX.UI.closePopover();
                              }
                              if (i.type === "group" && i.children) {
                                for (let f = 0; f < i.children.length; f++) {
                                  if (i.children[f].type === "group") {
                                    hasChildGroup = true;
                                  }
                                }
                              }

                              if (hasChildGroup) {
                                return;
                              } else {
                                if (n.levelChild > 1 && n.type === "group") {
                                  return;
                                }
                              }
                              if (this.sortTime) {
                                clearTimeout(this.sortTime);
                                this.sortTime = null;
                              }
                              if (n.type === "group") {
                                window.FX.UI.closePopover();
                                if (n.expanded) {
                                  window.FX.UI.showPopover({
                                    anchor: window.$(
                                      document.getElementById(n.key)
                                    ),
                                    content: window.$("<span/>").text(
                                      React.language(
                                        "app.edit.group.moveTo",
                                        {
                                          groupName: n.name,
                                        }
                                      )
                                    ),
                                    type: "dark",
                                  });
                                } else {
                                  this.sortTime = setTimeout(() => {
                                    window.FX.UI.showPopover({
                                      anchor: window.$(
                                        document.getElementById(n.key)
                                      ),
                                      content: window.$("<span/>").text(
                                        React.language(
                                          "app.edit.group.moveTo",
                                          {
                                            groupName: n.name,
                                          }
                                        )
                                      ),
                                      type: "dark",
                                    });
                                    node.context.triggerExpandActionExpand(
                                      node.event,
                                      n
                                    );
                                  }, 500);
                                }
                              } else {
                                if (entryMap[n.parent]) {
                                  window.FX.UI.closePopover();
                                  window.FX.UI.showPopover({
                                    anchor: window.$(
                                      document.getElementById(n.key)
                                    ),
                                    content: window.$("<span/>").text(
                                      React.language(
                                        "app.edit.group.moveTo",
                                        {
                                          groupName: entryMap[n.parent].name,
                                        }
                                      )
                                    ),
                                    type: "dark",
                                  });
                                }
                              }
                              this.newParentOverNode = node;
                            }
                          }}
                          onDrop={(node) => {
                            this.newParentOverNode = null;
                            this.startNode = null;
                            window.FX.UI.closePopover();
                            if (this.sortTime) {
                              clearTimeout(this.sortTime);
                              this.sortTime = null;
                            }
                            this.setState({ isEnter: false });
                            this.handleMoveNode(node);
                          }}
                          onDragEnd={() => {
                            if (this.sortTime) {
                              clearTimeout(this.sortTime);
                              this.sortTime = null;
                            }
                            this.startNode = null;
                            window.FX.UI.closePopover();
                          }}
                          onDragStart={(node) => {
                            if (this.sortTime) {
                              clearTimeout(this.sortTime);
                              this.sortTime = null;
                            }
                            this.startNode = node;
                          }}
                          icon={(rowInfo) => {
                            return (
                              appType !== 4 && (
                                <i
                                  className="icon-bsy-icongengduo1 nav nav-department-edit"
                                  style={{
                                    verticalAlign: "middle",
                                  }}
                                  //自定义菜单点击
                                  onClick={this.createFormDashMenu(
                                    rowInfo.data
                                  )}
                                ></i>
                              )
                            );
                          }}
                          switcherIcon={(rowInfo) => {
                            return (
                              <>
                                {rowInfo.data.type === "group" ? (
                                  <>
                                    <i
                                      className={
                                        rowInfo.expanded
                                          ? "icon-bsy-folder-open"
                                          : "icon-bsy-folder-close"
                                      }
                                    ></i>
                                    <span
                                      id={rowInfo.data.entryId}
                                      className="rc-tree-group-name"
                                      title={rowInfo.data.name}
                                    >
                                      {rowInfo.data.name}
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <i
                                      className={`node-icon icon-bsy-${rowInfo.data.type
                                        }${!rowInfo.data.hasCoop ? "-flow" : ""
                                        } ${rowInfo.data.iconClass <= 24
                                          ? `icon-bsy-form-${rowInfo.data.iconClass}`
                                          : `icon-new-bsy-form-${rowInfo.data.iconClass}`
                                        }`}
                                    />
                                    <span
                                      id={rowInfo.data.entryId}
                                      className="rc-tree-group-name"
                                      title={rowInfo.data.name}
                                    >
                                      {rowInfo.data.name}
                                    </span>
                                  </>
                                )}
                              </>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {!(
                    this.hasTrash() ||
                    this.hasDataView() ||
                    this.hasSetting() ||
                    this.hasVirtualAddressBook()
                  ) || appType === -1 ? (
                    ""
                  ) : (
                    <div
                      className={`bsy-app-set ${hideIcon > 3 ? "hideIcon" : ""
                        }`}
                    >
                      {this.hasDataView() && (
                        <div
                          className="bsy-data-view-btn btn"
                          onClick={() => {
                            this.createEvent(
                              appType,
                              BsyUtils.hasTokenEdit(appid) ||
                              (editAuth && appType !== 4)
                            );
                          }}
                        >
                          <i className="icon-new-shitu" />
                          <span>{React.language("editer_view")}</span>
                        </div>
                      )}
                      {this.hasSetting() && (
                        <div
                          className="bsy-app-set-btn btn"
                          onClick={() => {
                            this.appSetting(
                              appType,
                              BsyUtils.hasTokenEdit(appid) ||
                              (editAuth && appType !== 4)
                            );
                          }}
                        >
                          <i className="icon-new-shezhi" />
                          <span>{React.language("setting")}</span>
                        </div>
                      )}

                      {this.hasTrash() && (
                        <div
                          className="bsy-app-recycle-btn btn"
                          onClick={this.recyclePane}
                        >
                          <i className="icon-new-huishouzhan" />
                          <span>{React.language("recycle.bin")}</span>
                        </div>
                      )}
                      {this.hasVirtualAddressBook() && (
                        <div
                          className="bsy-virtual-address-btn btn"
                          onClick={this.openVirtualAddressBook}
                        >
                          <i className="icon-bsy-user-manager" />
                          <span>
                            {React.language("virtual.address.book")}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {appType === 3 && virtualType === 2 && (
              <BsyVirtualAddressBook
                appid={appid}
                appName={
                  React.language("virtual.address.book") + " - " + appName
                }
              />
            )}
          </>
        )}
        {emptyCont && (
          <div className="content-empty">
            <div className="empty-img">
              <img
                src={
                  window.rootDirectroy +
                  "/template/formreport/static/css/resources/images/img_meiyouquanxian.png"
                }
                alt=""
              />
            </div>
            <div
              className="empty-title"
              dangerouslySetInnerHTML={{ __html: emptyTip }}
            />
            <BsyIconBtn
              text={React.language("goHome")}
              click={() => {
                this.props.history.push("/team");
              }}
              type={"blue"}
            // mode={window.mode}
            ></BsyIconBtn>
          </div>
        )}
      </div>

    );
  }
}
export default withRouter(BsyDashboardApp);
